import React from 'react';
import FunnelChart from 'components/report-content/components/funnel-chart/FunnelChart';
import FunnelChartEditPanel from 'components/report-content/components/funnel-chart/FunnelChartEditPanel';
import { AbstractComponentBuilder, ComponentSettingsFunnelChart } from '@report-content';

export default class FunnelChartComponentBuilder extends AbstractComponentBuilder<ComponentSettingsFunnelChart> {
    getComponent() {
        return (
            <FunnelChart
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }

    getEditPanel() {
        if (this.contentSettings.context == 'view') {
            return null;
        }
        return (
            <FunnelChartEditPanel
                block={this.block}
                updateBlockSettings={this.updateBlockSettings}
                contentSettings={this.contentSettings}
                component={this.block.component}
                actions={this.actions}
            />
        );
    }
}
